export const ALL_DISCLOSURES_LIST_ENUMS_AND_TITLES = [
  {
    name: 'ConstructedBefore1978',
    title: 'When was your home built?',
    needsComment: false,
  },
  {
    name: 'LeadPaint',
    title: 'I have knowledge of lead-based paint or lead-based paint hazards.',
    needsComment: true,
  },
  {
    name: 'LeadPaintReports',
    title:
      'I have reports or records pertaining to lead-based paint or lead-based paint hazards.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'LeadPaintTreatment',
    title: 'I have knowledge of lead-based paint-related treatment.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Treatment Report',
  },
  {
    name: 'IsHomeDeleaded',
    title: 'I have knowledge that my home has been deleaded.',
    needsComment: true,
  },
  {
    name: 'LeadPaintingRiskReductionCertificate',
    title: 'I have a Lead-Based Paint Risk Reduction Certificate.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Certificate',
  },
  {
    name: 'LeadPaintingInspectionReport',
    title:
      'I have reports or records pertaining to lead-based paint or lead-based paint hazards.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'LeadPaintingRiskAssessmentReports',
    title:
      'I have reports or records pertaining to lead-based paint risk assessment.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'LeadPaintingLetterOfInterimControlReports',
    title: 'I have Letter Of Interim Control reports for lead-based paint.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'LeadPaintingLetterOfComplianceReports',
    title: 'I have Letter Of Compliance reports for lead-based paint.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'LeadPaintHazards',
    title:
      'I have knowledge of peeling of chipping paint, lead-contaminated dust or soil, or other visible lead-based paint hazards inside or around the property.',
    needsLocation: true,
    locationLabel:
      'Please list the location(s) where lead-based paint or hazards are present.',
    locationFieldName: 'leadPaintHazardsLocations',
  },
  {
    name: 'LeadBearingPlumbing',
    title: 'I have knowledge of lead-bearing plumbing present in the property.',
    needsLocation: true,
    locationLabel:
      'Please list the location(s) where lead-bearing plumbing is present.',
    locationFieldName: 'leadBearingPlumbingLocations',
  },
  {
    name: 'LeadServiceLines',
    title:
      'I have knowledge of lead service lines serving the dwelling unit, either on the private property or in public space.',
  },
  {
    name: 'LeadPublicWaterServiceReplaced',
    title:
      'I have knowledge that the portion of the lead water service line on public property has been replaced.',
    needsDate: true,
    dateLabel: 'When was the replacement done?',
    dateFieldName: 'leadPublicWaterServiceReplacedDates',
    datePlaceholder: 'Replacement Date (MM/DD/YYYY)',
    dateFormat: 'MM/DD/YYYY',
  },
  {
    name: 'LeadPrivateWaterServiceReplaced',
    title:
      'I have knowledge that the portion of the lead water service line on private property has been replaced.',
    needsDate: true,
    dateLabel: 'When was the replacement done?',
    dateFieldName: 'leadPrivateWaterServiceReplacedDates',
    datePlaceholder: 'Replacement Date (MM/DD/YYYY)',
    dateFormat: 'MM/DD/YYYY',
  },
  {
    name: 'LeadGovernmentPendingActionsAndNotices',
    title:
      'I have knowledge of pending actions or past penalties issued by the DC Government related to lead-based paint, lead water service lines, or lead-bearing plumbing for this property.',
  },
  {
    name: 'LeadDCWaterWebSite',
    title:
      'According to the DC Water website (dcwater.com/leadmap), what is the information listed for the lead water service line at this property?',
    hasLink: true,
    linkText: 'dcwater.com/leadmap',
    linkUrl: 'https://dcwater.com/leadmap',
  },
  // ---- Washington DC: property & building status (HOM-244) ----
  {
    name: 'HousingCodeViolations',
    title:
      'The Department of Buildings (or DCRA) has issued notices of housing-code infractions or violations for this home in the past 12 months.',
  },
  {
    name: 'CondoOrCoopAssociation',
    title:
      'This home is part of a condominium or cooperative association, or is converting to condo, co-op, or non-housing use.',
  },
  {
    name: 'IndoorMoldContaminationDC',
    title:
      'I have knowledge of indoor mold at or above the DOEE threshold in the home or building during the past 3 years that has not been remediated by a DC-certified indoor mold remediation professional.',
  },
  // ---- Washington DC: rent stabilization (shown only for RAD Rent Stabilized; gated by backend) ----
  {
    name: 'RentSurchargeOrPendingPetition',
    title:
      'There is a rent surcharge order, or a pending tenant petition, housing-provider petition, or voluntary agreement that could increase rent in the next 12 months.',
  },
  {
    name: 'RentIncreaseMethod',
    title: 'How may rent be increased for this unit?',
  },
  {
    name: 'Asbestos',
    title: 'I have knowledge of asbestos.',
    needsComment: false,
  },
  {
    name: 'AsbestosTreatment',
    title: 'I have knowledge of asbestos-related treatment.',
    needsComment: true,
  },
  {
    name: 'AsbestosReports',
    title:
      'I have reports or records pertaining to asbestos or asbestos hazards.',
    needsComment: false,
    filesRequired: true,
    fileLabel: 'Report',
  },
  {
    name: 'Death',
    title: 'I have knowledge of a death on premises in the last 3 years.',
    needsComment: true,
  },
  {
    name: 'SharedGasMeters',
    title: 'This home shares a gas meter with others.',
    needsComment: true,
  },
  {
    name: 'SharedElectricMeters',
    title: 'This home shares an electric meter with others.',
    needsComment: true,
  },
  {
    name: 'SharedWaterMeters',
    title: 'This home shares a water meter with others.',
    needsComment: true,
  },
  {
    name: 'Mold',
    title: 'I have knowledge of mold.',
    filesRequired: true,
    fileLabel: 'Report',
    needsComment: false,
  },
  {
    name: 'MoldTreatment',
    title: 'I have knowledge of mold-related treatment.',
    needsComment: false,
    filesRequired: true,
    fileLabel: 'Proof of Treatment',
  },
  {
    name: 'MoldReports',
    title: 'I have reports or records pertaining to mold or mold hazards.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'NoWaterConservingPlumbing',
    title:
      'I have not installed water-conserving plumbing fixtures (toilets, showerheads, etc.).',
    needsComment: true,
  },
  {
    name: 'MilitaryOrdnanceNearby',
    title:
      'I have knowledge of a former federal or state ordnance location within one mile of the home.',
    needsComment: true,
  },
  {
    name: 'IntentionToDemolishHome',
    title: 'I have applied for a permit to demolish the home.',
    needsComment: true,
  },
  {
    name: 'IsLocatedNearFloodZone',
    title:
      'I have received notice from a public agency that the property is located in a special flood hazard zone or an area of potential flooding.',
    needsComment: true,
  },
  {
    name: 'MortgageRequiresFloodInsurance',
    title: 'My mortgage holder requires me to carry flood insurance.',
    needsComment: true,
  },
  {
    name: 'HasFloodInsurance',
    title: 'I currently carry flood insurance for this home.',
    needsComment: true,
  },
  {
    name: 'IsIn100YearFloodPlain',
    title: 'My home sits on a 100-year floodplain.',
    needsComment: true,
  },
  {
    name: 'FloodedInLast5Years',
    title: 'My home has flooded in the last 5 years.',
    needsComment: true,
  },
  {
    name: 'HasSepticSystem',
    title: 'My home has a septic system.',
    needsComment: true,
  },
  {
    name: 'HasPublicSewage',
    title: 'My home has public sewage.',
    needsComment: true,
  },
  {
    name: 'FloodedAtLeastThreeTimesInLast5Years',
    title:
      'The living space or attached area has experienced flooding three or more times in the past five years.',
    needsComment: true,
  },
  {
    name: 'RadonDisclosureTheHomeownerHasKnowledge',
    title:
      'I have knowledge of or documents, records, or reports relating to radon in the home.',
    needsComment: false,
  },
  {
    name: 'RadonDisclosureTheHomeownerHasDocuments',
    title: 'I have radon reports.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'RadonDisclosureTheHomeownerHasKnowledgeOfConcentration',
    title: 'Radon concentrations were detected in my home.',
    needsComment: false,
  },
  {
    name: 'RadonDisclosureMitigationPerformed',
    title: 'My home was mitigated for radon.',
    needsComment: false,
  },
  {
    name: 'HasKnowledgeOfRadonAtOrAboveTheRecommended',
    title:
      'Radon concentrations (at or above the IEMA recommended Radon Action Level of 4.0 pCi/L) are known to be present within the dwelling unit.',
    needsComment: false,
  },
  {
    name: 'HasRadonRecordsOrReports',
    title:
      'I have radon records or reports pertaining to radon concentrations within the dwelling unit.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'IsLocatedInAFEMADesignatedFloodplain',
    title: 'The home is located in a FEMA designated floodplain.',
    needsComment: true,
  },
  {
    name: 'IsLocatedInASpecialFloodHazardArea',
    title: 'The home is located in a special flood hazard area.',
    needsComment: true,
  },
  {
    name: 'IsLocatedInAModerateRiskFloodHazardArea',
    title: 'The home is located in a moderate risk flood hazard area.',
    needsComment: true,
  },
  {
    name: 'HasPreviouslyExperiencedFloodDamageDueToANaturalFloodEvent',
    title:
      'The home has previously experienced flood damage due to a natural flood event.',
    needsComment: true,
  },
  {
    name: 'HasBeenTestedForContaminationOfIndoorAir',
    title: 'The home has been tested for contamination of indoor air.',
    needsComment: true,
  },
  {
    name: 'HasBuildingHadABedBugInfestationDuringThePastYear',
    title: 'The building has had a bed bug infestation during the past year.',
    needsComment: false,
  },
  {
    name: 'HasApartmentHadABedBugInfestationDuringThePastYear',
    title: 'The apartment has had a bed bug infestation during the past year.',
    needsComment: false,
  },
  {
    name: 'WasThereAnotherTypeOfPestOrInfestationIssueDuringThePastYear',
    title:
      'There was another type of pest or infestation issue during the past year.',
    needsComment: true,
  },
  {
    name: 'HasFireSprinklerSystem',
    title: 'The home has a fire sprinkler system.',
    needsComment: false,
  },
  {
    name: 'UsedToProduceMethamphetamine',
    title: 'I have knowledge methamphetamine production on the premises.',
    needsComment: true,
  },
  {
    name: 'IsBuildingWithMoreThanThreeUnits',
    title: 'This building has more than three units.',
    needsComment: true,
  },
  {
    name: 'IsRegisteredInMarylandDepartmentOfEnvironment',
    title:
      'This property is registered in the Maryland Department of Environment.',
    needsComment: true,
  },
  {
    name: 'IsNearMilitaryAirInstallation',
    title: 'This property is near a military air installation.',
    needsComment: false,
  },
  {
    name: 'IsInThirdFloorOrBelow',
    title: 'This unit is on the third floor or below.',
    needsComment: false,
  },
  {
    name: 'RadonTestInTheLast3Years',
    title: 'I have had a radon test in the last 3 years.',
    filesRequired: true,
    needsComment: false,
    fileLabel: 'Report',
  },
  {
    name: 'HasPeriodicPestControl',
    title: 'The unit has periodic pest control.',
    needsComment: true,
  },
  {
    name: 'OtherMaterialFacts',
    title: 'There are other material facts I should disclose.',
    needsComment: true,
  },
];
